
// export const API_ROOT_URL = 'http://atlas-riachao.crowde.com.br:8000/'
export const API_ROOT_URL = 'https://api.balancariachao.hopchat.com.br/api/v1/'
export const DESCRICAO_USUARIO = 'Usuário'
export const DESCRICAO_SENHA = 'Senha'
export const DESCRICAO_LOGIN = 'Login'
export const NOME_SISTEMA = 'Atlas'
export const NOME_SISTEMA_COMPLETO = 'CrowDe Atlas'
export const DESCRICAO_SISTEMA = 'Sistema para controle de pesagens'
export const DESCRICAO_INICIO = 'Início'
export const DESCRICAO_PESSOA = 'Clientes'
export const DESCRICAO_NOVO_PESSOA = 'Novo cliente'
export const DESCRICAO_MOTORISTAS = 'Transportadoras'
export const DESCRICAO_NOVO_MOTORISTA = 'Nova Transportadora'
export const DESCRICAO_AGRICULTORES = 'Agricultores'
export const DESCRICAO_SOBRE = 'Sobre'
export const DESCRICAO_SAIR = 'Sair'
export const DESCRICAO_ADMIN = 'Painel Admin'
export const DESCRICAO_NOVO = 'Novo'
export const DESCRICAO_READER_CODE = 'Leitor de código'
export const DESCRICAO_PESAGENS = 'Pesagens'
export const DESCRICAO_PESAGEM = 'Pesagem'
export const DESCRICAO_NOVA_PESAGEM = 'Nova Pesagem'
export const DESCRICAO_SUCCESS = 'Operação realizada com sucesso!'
export const DESCRICAO_SUCCESS_TO_PRINTER = 'Operação realizada com sucesso! Aguarde enquanto é realizada a impressão da nota.'


/* ##############################################################
# ROUTE URL's
##############################################################*/

export const ROUTE_URL_HOME = '/home'
export const ROUTE_URL_PESAGEM = '/pesagem'
export const ROUTE_URL_PESAGENS = '/pesagens'
export const ROUTE_URL_EDIT_PESAGEM = '/pesagem/:id'
export const ROUTE_URL_ABSTRACT_PESAGEM = '/resumo-pesagem/:id'
export const ROUTE_URL_AGRICULTORES = '/agricultores'
export const ROUTE_URL_AGRICULTOR = '/agricultor'
export const ROUTE_URL_EDIT_AGRICULTOR = '/agricultor/:id'
export const ROUTE_URL_SOBRE = '/sobre'
export const ROUTE_URL_TRANSPORTADORAS = '/transportadoras'
export const ROUTE_URL_TRANSPORTADORA = '/transportadora'
export const ROUTE_URL_EDIT_TRANSPORTADORA = '/transportadora/:id'
export const ROUTE_URL_READER_CODE = '/code'